import React, { memo, useState } from 'react';
import s from './SwitchTabs.scss';

const SwitchTabs = ({
  tabs,
  tabHandler,
  isToggle = false,
  activeTabIndex = null,
}) => {
  let selectedIndex = 1;
  if (activeTabIndex) {
    selectedIndex = activeTabIndex;
  } else {
    selectedIndex =
      tabs && Array.isArray(tabs) && tabs.length > 0 ? tabs[0].index : 1;
  }
  const [activeTab, setActiveTab] = useState(selectedIndex);

  const clearPrevTabAds = tab => {
    try {
      const ignoreFor = ['Party View', 'Alliance View'];
      if (ignoreFor.includes(tab.name)) {
        return;
      }
      if (typeof window !== 'undefined' && window._dfpObj) {
        const ads = window.App?.state?.revenue?.data?.ads?.layout;
        const aadsArray = window.googletag.pubads().getSlots();
        const lisad = [];
        if (ads) {
          const keys = Object.keys(ads);
          keys.forEach(k => {
            if (ads[k].refreshon) {
              const id = `${ads[k].divId}-1`;
              window._dfpObj._til_processedSlots = window._dfpObj._til_processedSlots.filter(
                li => li !== id,
              );
              window._dfpObj._til_defineSlot = window._dfpObj._til_defineSlot.filter(
                li => li !== id,
              );
              const innovRegex = new RegExp(ads[k].adCode, 'gi');
              const ad = aadsArray.find(e =>
                e.getAdUnitPath().match(innovRegex),
              );
              if (ad) {
                lisad.push(ad);
              }
            }
          });
          window.googletag.pubads().clear(lisad);
          window.googletag.destroySlots(lisad);
        }
      }
    } catch (error) {
      console.log(error);
      //
    }
  };
  const changeTab = tab => {
    setActiveTab(tab.index);
    if (tabHandler && typeof tabHandler === 'function') {
      tabHandler(tab);
    }
    clearPrevTabAds(tab);
  };

  return (
    <div
      className={`${
        isToggle ? s.swicthTabWrap : s.partyInfoWrap
      } globalSwitchTab`}
    >
      {tabs &&
        Array.isArray(tabs) &&
        tabs.length > 0 &&
        tabs.map(tab => (
          <div
            className={`${s.tab} ${activeTab === tab.index ? s.active : ''}`}
            onClick={() => changeTab(tab)}
          >
            <span>{tab.name}</span>
          </div>
        ))}
    </div>
  );
};

export default memo(SwitchTabs);
